import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKiaComponent } from './simple-icons-kia.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKiaComponent ],
    exports:      [ SimpleIconsKiaComponent ],
    bootstrap:    []
})
export class SimpleIconsKiaModule {}
